import { Routes } from '@angular/router';
import { ContactComponent } from './pages/contact/contact.component';
import { PriceComponent } from './pages/price/price.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { EventPublishComponent } from './pages/event-publish/event-publish.component';
import { OrderInsuranceComponent } from './pages/order-insurance/order-insurance.component';
import { FaqComponent } from './pages/faq/faq.component';
import { UsageTermsComponent } from './pages/usage-terms/usage-terms.component';
import { ReturnPoliticsComponent } from './pages/return-politics/return-politics.component';
import { BrandComponent } from './pages/brand/brand.component';

export const routes: Routes = [
  { path: 'contacto', component: ContactComponent },
  { path: 'precios', component: PriceComponent },
  { path: 'sobre-nosotros', component: AboutUsComponent },
  { path: 'publicar-evento', component: EventPublishComponent },
  { path: 'asegura-tu-compra', component: OrderInsuranceComponent },
  { path: 'preguntas-frecuentes', component: FaqComponent },
  { path: 'terminos-de-uso', component: UsageTermsComponent },
  { path: 'politicas-de-devolucion', component: ReturnPoliticsComponent },
  { path: 'logos', component: BrandComponent },
];
